// 顶部导航数据
export const TOP_BAR = [
  {
    id: 1,
    name: '公告',
  },
  {
    id: 2,
    name: '资料',
  },
  {
    id: 3,
    name: '文件研究',
  },
  {
    id: 4,
    name: '学程研究',
  },
  {
    id: 5,
    name: '在线课程',
  },
  {
    id: 6,
    name: '会议/直播',
  },
  {
    id: 7,
    name: '白板',
  },
  {
    id: 8,
    name: '成果展示',
  },
]

// 左侧栏映射数据
export const LEFT_BAR_MAP = {
  // 公告
  notice: [
    {
      name: '发布公告',
      icon: require('@/assets/discuss/notice-pub.png'),
      click: 'noticePub',
      creator: true,
    },
    {
      name: '公告列表',
      icon: require('@/assets/discuss/notice-list.png'),
      click: 'noticeList',
      change: 'noticeChange',
      delete: 'noticeDelete',
      hover: true,
    },
  ],
  // 资料
  resource: [
    {
      name: '添加资料',
      icon: require('@/assets/discuss/resource-add.png'),
      click: 'resourceAdd',
      creator: true,
    },
  ],
  // 文件研究
  file: [
    {
      name: '添加文件',
      icon: require('@/assets/discuss/file-add.png'),
      click: 'fileAdd',
      creator: true,
    },
    {
      name: '文件列表',
      icon: require('@/assets/discuss/file-list.png'),
      click: 'fileList',
      change: 'fileChange',
      delete: 'fileDelete',
      hover: true,
    },
  ],
  // 学程研究
  course: [
    {
      name: '添加学程',
      icon: require('@/assets/discuss/course-add.png'),
      click: 'courseAdd',
      creator: true,
    },
    {
      name: '学程列表',
      icon: require('@/assets/discuss/course-list.png'),
      click: 'courseList',
      change: 'courseChange',
      delete: 'courseDelete',
      hover: true,
    },
  ],
  // 在线课程
  curriculum: [
    {
      name: '添加课程',
      icon: require('@/assets/discuss/lesson-add.png'),
      click: 'lessonAdd',
      creator: true,
    },
    {
      name: '课程列表',
      icon: require('@/assets/discuss/lesson-list.png'),
      click: 'lessonList',
      change: 'lessonChange',
      delete: 'lessonDelete',
      hover: true,
    },
  ],
  // 会议/直播
  meeting: [
    {
      name: '添加会议',
      icon: require('@/assets/discuss/meeting-add.png'),
      click: 'meetingAdd',
      creator: true,
    },
  ],
  // 成果展示
  result: [
    {
      name: '添加文件',
      icon: require('@/assets/discuss/file-add.png'),
      click: 'fileAdd',
    },
  ],
}
